module.exports = __webpack_public_path__ + "static/media/ufpe.d6600551.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/teaching/assets/ufpe.jpg
// module id = 58
// module chunks = 0